module.exports = __webpack_public_path__ + "static/media/icons-ic-reschedule-demo-connected.dd81ad44.svg";